import { Directive, ElementRef, EventEmitter, HostListener, OnDestroy, Output, ViewChild } from '@angular/core';

@Directive({
    selector: '[insideViewport]',
    standalone: false
})
export class InsideViewportDirective implements OnDestroy{
  @Output() insideViewport = new EventEmitter();
  constructor(
    private elementRef: ElementRef
  ) { }

  // the element that you are observing (just add #yourElement in the template) for this  query to work
  private element: HTMLElement;
  private observer: IntersectionObserver;

  ngOnDestroy(): void {
    this.observer.disconnect();
  }

  ngAfterViewInit() {
    const threshold = 0.1; // how much % of the element is in view
    this.observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.insideViewport.emit(true);
                }else{
                  this.insideViewport.emit(false);
                }
            });
        },
        { threshold }
    );
    this.observer.observe(this.elementRef.nativeElement);
  }
}
